import { render, staticRenderFns } from "./VehicleRefStandardized.vue?vue&type=template&id=ee1d3f98&scoped=true"
import script from "./VehicleRefStandardized.vue?vue&type=script&lang=js"
export * from "./VehicleRefStandardized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1d3f98",
  null
  
)

export default component.exports